import { ErrorState } from '@ly360/ui';
import { useRouteError } from 'react-router';

/** Shown instead of the router's developer error page if a screen fails to render; the rest of the app stays usable. */
export function RouteError() {
  const error = useRouteError();
  return (
    <section className="card card-pad" style={{ margin: '1.25rem 0' }}>
      <ErrorState error={error} onRetry={() => window.location.reload()} />
    </section>
  );
}
